'use client'

import { Id, toast, ToastContent, ToastOptions } from 'react-toastify'

import { ToastType } from './types'
import { defaultToastOptions } from './utils/constants'

/**
 * Display toast
 *
 * @param {ToastType} type
 * @param {ToastContent} content
 * @param {ToastOptions} [options=defaultToastOption]
 * @return {Id}
 */
export const showToast = (
  type: ToastType,
  content: ToastContent,
  options: Partial<ToastOptions> = {},
): Id => {
  const optionsToApply = { ...defaultToastOptions, ...options }

  switch (type) {
    case 'success':
      return toast.success(content, optionsToApply)
    case 'error':
      return toast.error(content, optionsToApply)
    case 'info':
      return toast.info(content, optionsToApply)
    case 'warning':
      return toast.warn(content, optionsToApply)
    case 'default':
      return toast(content, optionsToApply)
    default:
      return toast(content, optionsToApply)
  }
}
